<template>
  <div
    class="icon-button"
    :class="[color, { outline: isOutline, disabled }, { size24: size24 }]"
    @click.stop="$_onClick()"
  >
    <i class="icon-button_icon" :class="icon" />
    <div v-if="tooltipText" class="icon-button__tooltip-wrap">{{ $t(tooltipText) }}</div>
  </div>
</template>
<script>
export default {
  name: 'IconButton',
  props: {
    icon: {
      type: String,
      default: '',
    },
    isOutline: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '',
    },
    tooltipText: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size24: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_onClick() {
      if (this.disabled) return;
      this.$emit('click');
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/icon-button';
</style>
